<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-body>
                    <h4 class="heading-1 mb-4">
                        <span>{{ titulo }}</span>
                        <div class="float-right">
                            <span class="text-primary">
                                <i
                                    class="fa fa-refresh fa-lg icon-button"
                                    title="Atualizar"
                                    @click.stop="
                                        $emit('obterConsultoriaAtualizada')
                                    "
                                ></i>
                            </span>
                        </div>
                    </h4>
                    <b-row>
                        <b-col sm="12" md="4">
                            <detalhe titulo="Id" :size="size1">{{
                                consultoria.idSolicitacao
                            }}</detalhe>
                            <detalhe
                                titulo="Cliente"
                                :size="size1"
                                v-if="consultoria.clientePJ"
                                >{{
                                    consultoria.clientePJ.razaoSocial
                                }}</detalhe
                            >
                            <detalhe
                                titulo="Credenciada"
                                :size="size1"
                                v-if="consultoria.credenciada && !fornecedor"
                                >{{
                                    consultoria.credenciada.razaoSocial
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.gestor && !solicitacao"
                                titulo="Gestor"
                                :size="size1"
                                >{{ consultoria.gestor }}</detalhe
                            >
                            <detalhe titulo="Status" :size="size1">
                                <app-status
                                    :status="consultoria.statusDescr"
                                ></app-status>
                            </detalhe>
                            <detalhe titulo="Solicitada em" :size="size1">{{
                                consultoria.dataSolicitacao
                                    ? $moment(
                                          consultoria.dataSolicitacao
                                      ).format('DD/MM/YYYY HH:mm:ss')
                                    : ''
                            }}</detalhe>
                            <detalhe
                                titulo="Limite aceitação"
                                :size="size1"
                                v-if="solicitacao"
                                >{{
                                    consultoria.dataLimiteAceitacao
                                        ? $moment(
                                              consultoria.dataLimiteAceitacao
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.dataAceitacao"
                                :titulo="
                                    `${
                                        consultoria.status ==
                                        consultoriaStatus.FINALIZADA_NAO_ACEITA_CREDENCIADA
                                            ? 'Não '
                                            : ''
                                    } Aceito em`
                                "
                                :size="size1"
                                >{{
                                    consultoria.dataAceitacao
                                        ? $moment(
                                              consultoria.dataAceitacao
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.dataPagamento"
                                titulo="Pago pelo Cliente em"
                                :size="size1"
                                >{{
                                    consultoria.dataPagamento
                                        ? $moment(
                                              consultoria.dataPagamento
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                            <detalhe
                                v-if="
                                    consultoria.dataAceitacaoCondicoesContratuais
                                "
                                titulo="Cond. Contratuais aceita em"
                                :size="size1"
                                >{{
                                    consultoria.dataAceitacaoCondicoesContratuais
                                        ? $moment(
                                              consultoria.dataAceitacaoCondicoesContratuais
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.dataContratacao"
                                titulo="Contratada em"
                                :size="size1"
                                >{{
                                    consultoria.dataContratacao
                                        ? $moment(
                                              consultoria.dataContratacao
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.dataContratacao"
                                titulo="Concluída em"
                                :size="size1"
                                >{{
                                    consultoria.dataConclusao
                                        ? $moment(
                                              consultoria.dataConclusao
                                          ).format('DD/MM/YYYY HH:mm:ss')
                                        : ''
                                }}</detalhe
                            >
                        </b-col>
                        <b-col sm="12" md="8">
                            <detalhe titulo="Descritivo" :size="size2">{{
                                consultoria.produtoDescricao
                            }}</detalhe>
                            <detalhe titulo="Valor" :size="size2">
                                {{ consultoria.produtoValor | currency }}
                            </detalhe>
                            <detalhe titulo="Comprometimento" :size="size2"
                                ><strong>{{ consultoria.idMov }}</strong>
                                <status-id-mov
                                    :consultoria="consultoria"
                                ></status-id-mov
                            ></detalhe>
                            <detalhe
                                v-if="consultoria.justificativaNaoAceite"
                                :size="size2"
                                titulo="Justificativa não aceite"
                                >{{
                                    consultoria.justificativaNaoAceite
                                }}</detalhe
                            >
                            <detalhe
                                v-if="consultoria.justificativaReprovacao"
                                :size="size2"
                                titulo="Justificativa reprovação"
                                >{{
                                    consultoria.justificativaReprovacao
                                }}</detalhe
                            >
                            <detalhe titulo="Atualizado em" :size="size2">{{
                                consultoria.dataAtualizacao
                                    ? $moment(
                                          consultoria.dataAtualizacao
                                      ).format('DD/MM/YYYY HH:mm:ss')
                                    : ''
                            }}</detalhe>
                        </b-col>
                    </b-row>
                </b-card-body>
                <b-card-footer>
                    <slot name="footer" v-bind="consultoria"></slot>
                    <btn-nao-aceitar
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-nao-aceitar>
                    <btn-aceitar
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-aceitar>
                    <btn-aceitar-condicoes-contratuais
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-aceitar-condicoes-contratuais>
                    <btn-comunicar-conclusao
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-comunicar-conclusao>
                    <btn-enviar-para-analise
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-enviar-para-analise>
                    <btn-aprovar-reprovar
                        class="ml-2"
                        :consultoria="consultoria"
                        :services="services"
                        @obterConsultoriaAtualizada="
                            $emit('obterConsultoriaAtualizada')
                        "
                    ></btn-aprovar-reprovar>
                </b-card-footer>
            </b-card>
        </b-col>
        <b-col sm="12" md="12" lg="12" xl="12" v-if="!solicitacao">
            <consultoria-anexos
                :consultoria="consultoria"
                :servicos="services"
                @obterConsultoriaAtualizada="
                    $emit('obterConsultoriaAtualizada')
                "
            ></consultoria-anexos>
            <consultoria-raht
                :consultoria="consultoria"
                :servicos="services"
                @obterConsultoriaAtualizada="
                    $emit('obterConsultoriaAtualizada')
                "
            ></consultoria-raht>
        </b-col>
    </b-row>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'
import BtnNaoAceitar from './BtnNaoAceitar'
import BtnAceitar from './BtnAceitar'
import BtnAceitarCondicoesContratuais from './BtnAceitarCondicoesContratuais'
import ConsultoriaAnexos from './ConsultoriaAnexos'
import ConsultoriaRaht from './ConsultoriaRaht'
import BtnComunicarConclusao from './BtnComunicarConclusao'
import BtnEnviarParaAnalise from './BtnEnviarParaAnalise'
import StatusIdMov from './StatusIdMov'
import BtnAprovarReprovar from './BtnAprovarReprovar'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String,
            default: () => 'APP SEBRAE - CONSULTORIA'
        },

        solicitacao: {
            type: Boolean,
            default: () => false
        },

        fornecedor: {
            type: Boolean,
            default: () => false
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            consultoriaStatus: consultoriaStatus
        }
    },

    computed: {
        size1() {
            if (this.consultoria.dataPagamento) {
                return '170'
            }
            return '100'
        },

        size2() {
            if (
                this.consultoria.justificativaNaoAceite ||
                this.consultoria.justificativaReprovacao
            ) {
                return '150'
            }
            return '120'
        }
    },

    components: {
        BtnNaoAceitar,
        BtnAceitar,
        BtnAceitarCondicoesContratuais,
        ConsultoriaAnexos,
        ConsultoriaRaht,
        BtnEnviarParaAnalise,
        BtnComunicarConclusao,
        StatusIdMov,
        BtnAprovarReprovar
    }
}
</script>
